<template>

  <ConfirmDialogue ref="confirmDialogue" />
  <MessageDialogue ref="messageDialogue" />

	<div class="load-container" :class="{'load' : isLoad}"></div>

	<template v-if="!isLoad">
  	<div class="component-container">
			<div class="component-container__left">

				<div class="component-work">
	  			<div class="component-work__body">
							{{ signal.signalProblem }}
	  			</div>
	  		</div>

				<div class="component-comment" v-if="signal.comment !== '' && signal.comment !== null">
					<div class="component-comment__label">
						Комментарий постановщика
					</div>
					<div class="component-comment__text">
						{{ signal.comment }}
					</div>
				</div>

				<div class="component-comment" v-if="signal.img && signal.img.length > 0">
					<div class="component-comment__label">
						Фотографии
					</div>
					<GalleryPhoto :images="signal.img" />
				</div>

				<div class="separator"><img src="@/assets/img/arrow-down-grey.svg"></div>

				<template v-if="task == null">

					<template v-if="isShowForm">

						<!--
						1. Кол-во дней на исполнение
						2. Выберите квалификацию
						3. Выберите сотрудника
						4. Выберите модуль
						5. Выберите эпик
						6. Выберите топик

						ttl
						functionId
						employeeId
						moduleId
						epicId
						topicId

						-->

						<div class="component-new">
							<div class="component-new__header">
								Создать задачу на основе сигнала
							</div>
							<div class="component-new__body">

								<div class="form-group">
									<div class="form-control">
										<input v-model="form.name" type="text">
										<label> Название задачи </label>
									</div>
								</div>

								<div class="form-group">
									<div class="form-control">
										<input v-model="form.ttl" type="number">
										<label> Кол-во дней на исполнение </label>
									</div>
								</div>

								<div class="form-group">
									<SelectPicker 
										v-model="form.functionId" 
										:list="functions" 
										label="Квалификация" 
										isClear="true" 
										@setValue="() => { 
											form.employeeId = null; 
										}"/>
								</div>

								<div class="form-group">
									<SelectPicker 
										v-model="form.employeeId" 
										:list="filteredEmployees" 
										label="Исполнитель" 
										isClear="true"
										/>
								</div>
								
								<div class="form-group">
									<SelectPicker 
										v-model="form.moduleId" 
										:list="modulesList" 
										label="Выберите модуль" 
										defaultTop="true" 
										isClear="true"
										@setValue="() => { form.epicId = null; form.topicId = null; }"
									/>
								</div>
								
								<div class="form-group">
									<SelectPicker 
										v-model="form.epicId" 
										:list="epicList" 
										label="Выберите эпик" 
										defaultTop="true" 
										isClear="true"
										@setValue="() => { form.topicId = null; }"
									/>
								</div>

								<div class="form-group">
									<SelectPicker 
										v-model="form.topicId" 
										:list="topicList" 
										label="Выберите топик" 
										defaultTop="true" 
										isClear="true" 
									/>
								</div>

								<div class="btn-group">
									<a class="btn btn--lg btn--default btn--inline" :class="{'disabled': isDisabledSaveButton}" @click="saveTask($event)">
										<div class="btn--text"> Сохранить </div>
										<div class="btn--loader"></div>
									</a>
								</div>

							</div>
						</div>

					</template>

					<template v-else>

						<a class="btn btn--lg btn--default" style="width: 100%;" @click="isShowForm = true">
							<div class="btn--text"> Создать задачу на основе сигнала </div>
							<div class="btn--loader"></div>
						</a>

					</template>

				</template>

				<template v-else>

					<div class="component-info">
		  			<div class="component-info__header">
		  				Задача на основе сигнала
		  			</div>
		  			<div class="component-info__body">

		  				<div class="component-info__item">
		  					<div class="component-info__badge">
									<!-- <img src="@/assets/img/task-icons/2.svg"> -->
									abc
		  					</div>
		  					<div class="component-info__content">
		  						<div class="component-info__label">
		  							Название
		  						</div>
		  						<div class="component-info__data">
		  							{{ task.name }}
		  						</div>
		  					</div>
		  				</div>

		  				<div class="component-info__item">
		  					<div class="component-info__badge">
		  						<img src="@/assets/img/task-icons/1.svg">
		  					</div>
		  					<div class="component-info__content">
		  						<div class="component-info__label">
		  							Дата назначения
		  						</div>
		  						<div class="component-info__data">
		  							<span> {{ $moment(task.dateCreated).format('DD.MM.YYYY') }} </span>
		  						</div>
		  					</div>
		  				</div>
		  				<div class="component-info__item">
		  					<div class="component-info__badge">
		  						<img src="@/assets/img/task-icons/3.svg">
		  					</div>
		  					<div class="component-info__content">
		  						<div class="component-info__label">
		  							Квалификация
		  						</div>
		  						<div class="component-info__data">
		  							{{ functionNameById(task.function.id) }}
		  						</div>
		  					</div>
		  				</div>
		  				<div class="component-info__item">
		  					<div class="component-info__badge">
									<img src="@/assets/img/task-icons/2.svg">
		  					</div>
		  					<div class="component-info__content">
		  						<div class="component-info__label">
		  							Исполнитель
		  						</div>
		  						<div class="component-info__data">
		  							{{ employeeNameById(task.empl.id) }}
		  						</div>
		  					</div>
		  				</div>
		  			</div>
		  		</div>


				</template>


			</div>
  		<div class="component-container__right">
		  	<div class="component-info">
	  			<div class="component-info__header">
	  				<span> Назначено </span>
	  				<span> {{ $moment(signal.dateCreated).format('DD.MM.YYYY') }} </span>
	  			</div>
		  		<div class="component-info__body">

  					<div class="component-info__item">
	  					<div class="component-info__badge">
	  						<img src="@/assets/img/task-icons/4.svg">
	  					</div>
	  					<div class="component-info__content">
	  						<div class="component-info__label">
	  							Место
	  						</div>
	  						<div class="component-info__data">
	  							<span v-if="signal.signalItem !== '' || signal.signalItem !== null"> {{ signal.signalItem }} </span>
									<span v-else> - </span>
	  						</div>
	  					</div>
	  				</div>

	  				<div class="component-info__item">
	  					<div class="component-info__badge">
	  						<img src="@/assets/img/task-icons/2.svg">
	  					</div>
	  					<div class="component-info__content">
	  						<div class="component-info__label">
	  							Сотрудник
	  						</div>
	  						<div class="component-info__data">
	  							{{ employeeName }}
	  						</div>
	  					</div>
	  				</div>

		  		</div>
		  	</div>
  		</div>

		</div>
	</template>

</template>

<script setup>
  import ConfirmDialogue from '@/components/modals/ConfirmDialogue.vue';
  import MessageDialogue from '@/components/modals/MessageDialogue.vue';

  import GalleryPhoto from '@/components/ux/GalleryPhoto.vue';
  import SelectPicker from '@/components/ux/SelectPicker.vue';
	// import DatePicker from '@/components/ux/DatePicker.vue';

  // import IconControl from '@/components/icons/task-types/IconControl.vue';
  // import IconWork from '@/components/icons/task-types/IconWork.vue';
  // import IconReview from '@/components/icons/task-types/IconReview.vue';
</script>

<script>

  export default {

    name: 'PageTrackerHouseTask',

    props: ['signal_id', 'house_id', 'organization_id'],

    emits: ['createTask'],

    data: () => ({

      isLoad: true,
      isShowForm: false,

      signal: null,
      task: null,

      form: {
	    	ttl: null,
	    	name: null,
	    	functionId: null,
	    	employeeId: null,
	    	moduleId: null,
	    	epicId: null,
	    	topicId: null,
	    },

      employees: [],
      modules: [],

    }),

    watch: {
    	// Устанавливаем сотрудника в зависимости от отфильтрованного списка
    	'form.functionId': function () {
        const idx = this.filteredEmployees.findIndex( (employee) => { return employee.id == this.form.employeeId });
        this.form.employeeId = (idx !== -1) ? this.form.employeeId : null;
    	} 
    },

    computed: {
    	employeeName() {
    		let name = '';
    		if(this.signal.employee.lastName !== null) {
    			name += this.signal.employee.lastName;
    		}
    		if(this.signal.employee.firstName !== null) {
    			name += ' ' + this.signal.employee.firstName;
    		}
    		if(this.signal.employee.middleName !== null) {
    			name += ' ' + this.signal.employee.middleName;
    		}
    		return name;
    	},
    	modulesList () {
    		const list = [];
    		for (let numModule in this.modules) {
    			list.push({id: this.modules[numModule].taskModuleId, name: numModule + ' - ' + this.modules[numModule].name});
    		}
    		return list;
    	},
    	epicList () {
    		const list = [];
    		for (let numModule in this.modules) {
    			if(this.modules[numModule].taskModuleId == this.form.moduleId) {
    				for (let numEpic in this.modules[numModule].epics) {
    					list.push({id: this.modules[numModule].epics[numEpic].taskEpicId, name: numEpic + ' - ' + this.modules[numModule].epics[numEpic].name });
    				}
    			}
    		}
    		return list;
    	},
			topicList () {
				const list = [];
    		for (let numModule in this.modules) {
    			if(this.modules[numModule].taskModuleId == this.form.moduleId) {
    				for (let numEpic in this.modules[numModule].epics) {
    					if(this.modules[numModule].epics[numEpic].taskEpicId  == this.form.epicId) {
    						for (let numTopic in this.modules[numModule].epics[numEpic].topics) {
    							if(this.modules[numModule].epics[numEpic].topics[numTopic].taskTopicId !== null) {
    								list.push({id: this.modules[numModule].epics[numEpic].topics[numTopic].taskTopicId, name: numTopic + ' - ' + this.modules[numModule].epics[numEpic].topics[numTopic].name });
    							}
    						}
    					}
    				}
    			}
    		}
    		return list;
			},
    	functions () {
        return this.$store.state.functions;
      },
      functionNameById () {
      	return (id) => {
	      	const idx = this.functions.findIndex( (item) => { return item.id == id } );
	      	return this.functions[idx].name;
      	}
      },
      employeeNameById () {
      	return (id) => {
	      	const idx = this.employees.findIndex( (item) => { return item.id == id } );
	      	return this.employees[idx].name;
      	}
      },
      filteredEmployees () {
    		let list = [];
	        if(this.form.functionId !== null) {
	          	this.employees.forEach((employee) => {
	          		const idx = employee.functions.findIndex((func) => { return func.id === this.form.functionId });
	          		if(idx !== -1) { list.push(employee); }
	          	});
	        } else {
	          list = this.employees;
	        }
	        return list;
    	},
    	isDisabledSaveButton () {
    		const data = [];
      	for (let key in this.form) {
      		data.push(this.form[key]);
      	}
      	return data.includes(null) ? true : false;
    	},
    },

    created () {
    	Promise.all([ 
  			this.loadSignal(),
				this.loadModules(),
				this.loadEmployees(),
	      this.$store.dispatch('getFunctions'),
  		])
    	.then(() => {
      	this.beforeRender();
      	this.isLoad = false;
    	})
    	.catch((e)=> {
      	console.log(e);
    	})
    },

    methods: {
    	
    	beforeRender () {

    	},

    	async loadSignal () {
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/tracker/' + this.signal_id);
        this.signal = data;
        if(this.signal.taskId !== null) {
        	await this.loadTask(this.signal.taskId);
        }
    	},

    	async loadTask (id) {
      	const {data} = await this.axios.get(this.$store.state.api_endpoint + '/tracker/' + this.house_id + '/tasks/' + id);
      	this.task = data;
    	},

    	async loadEmployees () {
  	  	const { data } = await this.axios.get(this.$store.state.api_endpoint + '/employees/?companyId=' + this.organization_id + '&detailed=true');
        this.employees = data.data;
  	  },

  	  async loadModules () {
  	  	const { data } = await this.axios.get(this.$store.state.api_endpoint + '/tracker/' + this.house_id + '/modules');
        this.modules = data.modules;
  	  },

  	  // Сохранить задачу
			async saveTask (e) {
				
				const btn = e.currentTarget;
				btn.classList.add('btn--load');

				const params = {... this.form};

				params.signalId = this.signal.id;
				params.houseId = Number(this.house_id);

				try {
					const {data} = await this.axios.post(this.$store.state.api_endpoint + '/tracker/customTask', params);
					this.task = data;
					this.signal.taskId = this.task.id;

					await this.$store.dispatch('fetchData');

					this.$emit('createTask');

				} catch (e) {
					this.$refs.messageDialogue.show({ message: e.message, okButton: 'Подтвердить' });
				}


				// try {
				// 	// Создаём дочернюю задачу
				// 	const {data} = await this.axios.post(this.$store.state.api_endpoint + '/checklist/' +  this.task.actionType + '/' + this.task.empl.id + '/' + this.task.id + '/childTemplate', this.form);
				// 	// Обновляем шаблон (уже есть ID)
        // 	this.template = data;
        // 	// Задача было локальной, вызываем настоящее создание
				// 	await this.axios.post(this.$store.state.api_endpoint + '/checklist/create/childTemplate', {ids: [ this.task.id ]});
				// 	// Сигнализируем
				// 	this.$refs.messageDialogue.show({
        //   	message: 'Задача поставлена',
        //   	okButton: 'Продолжить',
        //   	cancelButton: false,
        // 	});
				// } catch (e) {
				// 	this.$refs.messageDialogue.show({ message: e.message, okButton: 'Подтвердить' });
				// }

				btn.classList.remove('btn--load');
			
			},


    },
  }
</script>


<style scoped>

	.separator {
		width: 100%;
		height: 50px;
		background-position: center;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}



	.component-container {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 15px;
	}

	.component-container__left {
		width: 60%;
	}

	.component-container__right {
		width: 40%;
	}



	.component-new {
		background-color: var(--cozh-white);
		border-radius: 15px;
		width: 100%;
	}
	.component-new__header {
		border-bottom: 1px solid var(--cozh-light-grey);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		height: 65px;
		padding: 0px 25px;
		    font-size: 18px;
    font-weight: 500;
    line-height: 1.1;
	}
	.component-new__body {
		padding: 20px 20px;
	}






	.component-info {
		background-color: var(--cozh-white);
		border-radius: 15px;
		overflow: hidden;
		width: 100%;
	}
	
	.component-info__header {
		border-bottom: 1px solid var(--cozh-light-grey);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		height: 65px;
		padding: 0px 25px;
		font-size: 18px;
    font-weight: 500;
	}

	.component-info__header span:first-child {
 		margin-right: 10px;
		color: var(--cozh-grey);
 		font-size: 15px;
	 	line-height: 1.1;
	 	word-wrap: break-word;
	}

	.component-info__header span:last-child {
		font-size: 15px;
    font-weight: 500;
    line-height: 1.1;
    word-wrap: break-word;
	}
	.component-info__body {
		padding: 8px 20px;
	}

	.component-info__item {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		padding-top: 12px;
		padding-bottom: 12px;
	}

	.component-info__item:not(:last-child) {
		border-bottom: 1px solid var(--cozh-light-grey);
	}


	.component-info__badge {
		height: 40px;
    width: 40px;
    min-height: 40px;
    min-width: 40px;
    background-color: rgba(var(--cozh-blue-code), .12);
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    color: var(--cozh-blue);
    font-weight: 600;
    font-size: 13px;
	}

	.component-info__content {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.component-info__label {
		color: var(--cozh-grey);
 		font-size: 10px;
 		font-weight: 500;
 		text-transform: uppercase;
 		letter-spacing: 0.50px;
 		word-wrap: break-word
	}

	.component-info__data {
		font-size: 15px;
		font-weight: 500;
		line-height: 1.2;
 		word-wrap: break-word;
	}

	.component-info__path {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}
	.component-info__path-item {
 		font-size: 15px;
	 	font-weight: 500;
	 	max-width: 50%;
	 	text-overflow: ellipsis;
	 	overflow: hidden;
	 	white-space: nowrap;
	 	position: relative;
	}
	.component-info__path-item:not(:last-child) {
		padding-right: 32px;
	 	max-width: calc(50% + 20px);
	}
	.component-info__path-item:not(:last-child)::before {
		content: url('../../assets/img/check-right-grey.svg');
		position: absolute;
		right: 13px;
		top: 50%;
		transform: translateY(-50%);
	}









	.component-comment {
		background-color: var(--cozh-white);
		border-radius: 15px;
		padding: 20px 20px;
		margin-top: 15px;
	}
	.component-comment__label {
		color: var(--cozh-grey);
	 	font-size: 10px;
	 	font-weight: 500;
	 	text-transform: uppercase;
	 	letter-spacing: 0.50px;
	 	margin-bottom: 10px;
	}
	.component-comment__text {
 		font-size: 14px;
 		word-wrap: break-word;
	}



	.component-work {
		background-color: var(--cozh-white);
		border-radius: 15px;
		min-height: 340px;
	}
	
	.component-work__header {
		border-bottom: 1px solid var(--cozh-light-grey);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		height: 65px;
		padding: 0px 13px;
	}

	.component-work__body {
		padding: 20px 20px;
		font-size: 20px;
		line-height: 1.4;
		font-weight: 500;

	}

	.component-work__badge {
		height: 40px;
		width: 40px;
		border-radius: 50%;
		margin-right: 12px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background-color: rgba(233, 241, 244, 1);
	}

	.component-work__num {
	 	font-size: 15px;
	 	font-weight: 500;
	 	line-height: 1.1;
	 	word-wrap: break-word;
		margin-right: 20px;
	}

	.component-work__status {
	 	font-size: 15px;
	 	line-height: 1.1;
	 	word-wrap: break-word;
	 	padding-left: 15px;
	 	position: relative;
	 	font-weight: 500;
	}

	.component-work__status > span {
    height: 7px;
    width: 7px;
    border-radius: 50%;
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
	}


	.component-work--assigned .component-work__badge {
		background-color: rgba(233, 241, 244, 1);
	}
	.component-work--done .component-work__badge {
		background-color: rgba(233, 241, 244, 1);
	}
	.component-work--issue .component-work__badge {
		background-color: rgba(var(--cozh-orange-code), .12);
	}
	.component-work--failed .component-work__badge {
		background-color: rgba(var(--cozh-red-code), .12);
	}
	.component-work--expired .component-work__badge {
		background-color: rgba(var(--cozh-dark-red-code), .08);
	}

</style>